import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { Link, Stack, Typography } from '@mui/material';

import ResetPasswordForm from '../../sections/auth/ResetPasswordForm';

// Pagina a la que lleva el enlace del correo de "olvide mi contrasena" (?token=...&email=...).
export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();

  return (
    <Stack spacing={3}>
      <Stack spacing={1} sx={{ textAlign: 'center' }}>
        <Typography variant="h4">Nueva contraseña</Typography>
      </Stack>

      <ResetPasswordForm token={searchParams.get('token') || ''} email={searchParams.get('email') || ''} />

      <Typography variant="body2" sx={{ textAlign: 'center' }}>
        <Link component={RouterLink} to="/login">
          Volver a iniciar sesión
        </Link>
      </Typography>
    </Stack>
  );
}
